import { contracts } from '@constants';
import { refuelAbi } from '@assets/abi';
import { getContract } from '@api/ethereum';

export function getContractRefuelFactory(chainId: number) {
  return getContract(contracts[chainId]?.Refuel, refuelAbi);
}
